import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import Country from '../../../../../../types/country/Country';
import DealershipWriteDTO from '../../../../../../types/dealership/DealershipWriteDTO';
import { CountryService } from '../../../../services/country.service';
import { DealershipService } from '../../../../services/dealership.service';

@Component({
    selector: 'app-create-dealership-dialog',
    templateUrl: './create-dealership-dialog.component.html',
    styleUrls: [ './create-dealership-dialog.component.scss' ],
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        IconField,
        InputIcon,
        IftaLabelModule,
        Select,
    ]
})
export class CreateDealershipDialogComponent implements OnInit {
    @Input() visible: boolean = false;
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() dealershipCreated: EventEmitter<DealershipWriteDTO> = new EventEmitter<DealershipWriteDTO>();

    constructor(
        private dealershipService: DealershipService,
        private messageService: MessageService,
        private countryService: CountryService
    ) {
    }

    public dealership: DealershipWriteDTO = new DealershipWriteDTO({});
    public availableCountries: Country[] = [];
    public loading = false;
    public loadingCountries = false;

    public ngOnInit() {
        this.loadCountries();
    }

    get saveDisabled(): boolean {
        return !this.dealership.name || !this.dealership.countryId;
    }

    public close() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public loadCountries() {
        this.loadingCountries = true;
        this.countryService
            .getAllCountries()
            .then((countries) => {
                this.availableCountries = countries;
            })
            .catch((error) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
            })
            .finally(() => {
                this.loadingCountries = false;
            });
    }

    public saveDealership() {
        this.loading = true;

        this.dealershipService
            .createDealership(this.dealership)
            .then(() => {
                this.dealershipCreated.emit(this.dealership);
                this.close();
            })
            .catch((error) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
            })
            .finally(() => {
                this.dealership = new DealershipWriteDTO({});
                this.loading = false;
            });
    }
}
